import React, { useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";

import { RoutesNames } from "../../components/utils/routes";
import { useToastSuccessful } from "../../Hooks/useToastSuccessful";
import { useToastInfo } from "../../Hooks/useToastInfo";
import { useToastLoading } from "../../Hooks/useToastLoading";
import { useToastError } from "../../Hooks/useToastError";
import { GET_STATE_BY_COUNTRY } from "../../Graphql/queries/queryGetStateByCountry";
import { MUTATION_CREATE_BIOMETRIC_REGISTRATION } from "../../Graphql/mutations/mutationCreateRegisterBiometric";
import { LoadingScreen } from "../../components/StatusScreens/LoadingScreen";
import IconBack from "../../components/Icons/IconBack";
import DataForm from "../../components/form/DataForm";
import { validationBiometric } from "../../components/validations/validationBiometric";
import IconInfoYellow from "../../components/Icons/IconInfoYellow";
import ModalInformation from "../../Modals/ModalInformation";
import ModalTermsConditions from "../../Modals/ModalTermAndConditions/ModalTermsConditions";

import {
  BackButton,
  ContainerContent,
  ContainerGlobal,
  ContainerInfo,
  ContainerInformation,
  ContainText,
  Header,
  RedText,
  TextBack,
  TextBar,
  TextHeader,
  TextInfo,
  TextInformation,
  TextInformative,
  Title,
  TopText,
  ContainerBackAndInfo,
  ContainerTransparent,
} from "../../styles/PageStyles/LegalAndDocumental/stylesBiometricRegistration";

const BiometricRegistration = () => {
  const navigate = useNavigate();
  // eslint-disable-next-line
  const SITE_KEY = process.env.REACT_APP_SITE;
  // eslint-disable-next-line
  const TERMS_HABEAS_DATA = process.env.REACT_APP_TERMS_HABEAS_DATA;
  const [modalVisible, setModalVisible] = useState(false);
  const [modalInformation, setModalInformation] = useState(false);
  const [terms, setTerms] = useState(null);
  const [captcha, setCaptcha] = useState(null);
  const [dataForm, setDataForm] = useState({
    data: {},
    reset: null,
  });
  const [location, setLocation] = useState({
    state: "",
    city: "",
  });
  const toastSuccessful = useToastSuccessful();
  const toastInfo = useToastInfo();

  const { error, data, loading } = useQuery(GET_STATE_BY_COUNTRY);

  const [sendData, { error: errorMutation, loading: loadingMutation }] = useMutation(
    MUTATION_CREATE_BIOMETRIC_REGISTRATION,
    {
      onCompleted: (e) => {
        setTimeout(() => {
          toastSuccessful(e.createApplicationForm.message);
        }, 500);
        setTimeout(() => {
          navigate(RoutesNames.home);
        }, 1000);
      },
      onError: (err) => console.error(err),
    },
  );

  useToastError(error || errorMutation);
  useToastLoading(loadingMutation);

  const onHandleSubmit = (values, { resetForm }) => {
    if (location.state === "" && location.city === "") {
      return toastInfo("Debe seleccionar un departamento y un municipio.");
    }
    if (values.rumv === "") {
      return toastInfo("Debe ingresar un RUMV.");
    }
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(SITE_KEY, { action: "submit" }).then((token) => {
        setCaptcha(token);
      });
    });
    if (
      (values.phoneNumber.length === 7 || values.phoneNumber.length === 10) &&
      (values.secondaryPhoneNumber.length === 7 || values.secondaryPhoneNumber.length === 10)
    ) {
      setModalVisible(true);
      setDataForm({
        data: values,
        reset: resetForm,
      });
    } else {
      return toastInfo("Los números de teléfono deben tener 7 o 10 números.");
    }
  };

  const onHandleAccept = (info) => {
    setModalVisible(false);
    sendData({
      variables: {
        firstName: info.data.name,
        lastName: info.data.lastName,
        phoneNumber: info.data.phoneNumber,
        secondaryPhoneNumber: info.data.secondaryPhoneNumber,
        optionalPhoneNumber: info.data.whatsAppPhoneNumber || null,
        stateId: parseInt(location.state),
        citiesId: location.city,
        termsAndConditionsAcceptedId: terms,
        email: info.data.email,
        step: "BIOMETRIC_REGISTRY",
        neighborhood: info.data.neighborhood || undefined,
        rumvNumber: info.data.rumv,
        helpType: "FACE_TO_FACE",
        token: captcha,
      },
    });
    info.reset();
  };

  if (loading) return <LoadingScreen />;

  const states = data?.getStateByCountry.data;

  return (
    <ContainerGlobal>
      <ContainerContent>
        <TopText>
          Este portal pretende únicamente ayudar a gestionar los trámites, por lo que los tiempos, aceptación, negación,
          y gestión depende exclusivamente de las entidades encargadas.
        </TopText>
        <Header>
          <Title>REGISTRO BIOMÉTRICO</Title>
          <TextHeader>
            Este proceso lo podrás realizar directamente y de forma gratuita en la página de Migración Colombia
            <a href="https://www.migracioncolombia.gov.co"> https://www.migracioncolombia.gov.co</a>. A continuación,
            podrás inscribirte para jornada presencial, SOLO aplica para municipios que estén fuera del área
            metropolitana, sí NO lo está deberás realizarlo directamente con Migración Colombia.
          </TextHeader>
        </Header>
        <ContainerBackAndInfo>
          <BackButton onClick={() => navigate(-1)}>
            <IconBack color="#000" width={20} height={20} />
            <TextBack>Atrás</TextBack>
          </BackButton>
          <ContainerInformation onClick={() => setModalInformation(true)}>
            <IconInfoYellow />
            <TextInformation>Nota informativa aquí</TextInformation>
          </ContainerInformation>
          <div />
        </ContainerBackAndInfo>
        <ModalInformation modalOpen={modalInformation} setModalOpen={setModalInformation}>
          <ContainerInfo>
            El Área metropolitana del Valle de Aburrá como región está conformada por diez municipios, a saber, de sur a
            norte: Caldas, La Estrella, Sabaneta, Envigado, Itagüí en el sur, Medellín en el centro del valle, Bello,
            Copacabana, Girardota y Barbosa en el norte.
          </ContainerInfo>
        </ModalInformation>
        <ContainerTransparent>
          <TextInfo>
            *Las jornadas presenciales se realizarán siempre y cuando se inscriba suficientes personas.
            <div>
              *El equipo programador de la jornada revisará el número mínimo de personas requerido para realizarla según
              cada municipio.
            </div>
            *¡OJO se te informará telefónicamente la programación o información importante de las jornadas!.
          </TextInfo>
          <TextInformative>
            Recuerda: Para este trámite debiste haber finalizado el <RedText>paso # 1</RedText> o haber realizado
            previamente el registro RUMV.
          </TextInformative>
          <ContainText>
            <TextBar>Quiero inscribirme en una jornada presencial para el proceso del registro BIOMÉTRICO</TextBar>
          </ContainText>
          <DataForm
            handleSubmit={onHandleSubmit}
            dataState={states || []}
            setLocation={setLocation}
            validationSchema={validationBiometric}
            rumv={true}
          />
        </ContainerTransparent>
      </ContainerContent>
      <ModalTermsConditions
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        press={() => onHandleAccept(dataForm)}
        setTerms={setTerms}
        idTermsAndConditions={TERMS_HABEAS_DATA}
      />
    </ContainerGlobal>
  );
};

export default BiometricRegistration;
